export enum MultiMembershipActionsButtons {
    AddAccount = 'Add Account',
    HaveCode = 'I already have a code',
    LinkAccounts = 'Link Accounts'
}
